export default __webpack_public_path__ + "atomic/_patterns/01-atoms/link-list-item/_link-list-item.twig";